import { render } from "./ModalPrint.vue?vue&type=template&id=64fc4e08"
import script from "./ModalPrint.vue?vue&type=script&lang=js"
export * from "./ModalPrint.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__